import { styled } from "@mui/material"

export const PgContainer = styled("div")({
  width: "100%",
  maxWidth: "1600px",
  margin: "0 auto",
  padding: 0,
})
